import { Rate, Tag } from "antd";
import { CombineCatalogPriceLineZoneServiceProvider } from "hooks/catalog-price-zone-service-provider";
import { useMemo } from "react";

interface CatalogPriceUrbanCenterCellProps {
  value?: {
    serviceProviderId: number;
    serviceProviderName: string;
    formattedAddress: string;
  };
  products: CombineCatalogPriceLineZoneServiceProvider["products"];
  catalogPriceLineZones?: {
    zoneId: number;
    zoneName: string;
    distanceByCar?: string;
  }[];
}
const getRandomRate = () => {
  const base = 4 + Math.floor(Math.random() * 2); // 4 hoặc 5
  const half = Math.random() > 0.5 ? 0.5 : 0;
  return base + half > 5 ? 5 : base + half;
};

const getRandomRateCount = () => Math.floor(Math.random() * 190) + 10;

const CatalogPriceServiceProviderCell = (
  props: CatalogPriceUrbanCenterCellProps
) => {
  const { value, catalogPriceLineZones, products } = props;

  const getMostRecentOrderDate = (
    products: CombineCatalogPriceLineZoneServiceProvider["products"]
  ) => {
    console.log(">>> getMostRecentOrderDate starting", {
      productsCount: products?.length,
      providerId: value?.serviceProviderId,
    });
    if (!products || products.length === 0) return null;

    const allDates: { date: number; origin: string }[] = [];

    products.forEach((product) => {
      console.log(">>> Processing product", {
        productName: product.productName,
        selectedPriceFamilyId: product.selectedPriceFamilyId,
        hasPriceFamilies: !!product.priceFamilies,
      });
      if (product.selectedPriceFamilyId && product.priceFamilies) {
        // Strict: If family selected, use ONLY family-related dates
        const selectedFamily = product.priceFamilies.find(
          (f) =>
            f.id === product.selectedPriceFamilyId &&
            f.serviceProviderId === value?.serviceProviderId
        );

        // Family-level date
        if (selectedFamily?.orderCreatedAt) {
          console.log(">>> Found date from family", {
            familyName: selectedFamily.name,
            date: selectedFamily.orderCreatedAt,
          });
          allDates.push({
            date: new Date(selectedFamily.orderCreatedAt).getTime(),
            origin: `Family: ${selectedFamily.name}`,
          });
        }
        console.log("selectedFamily", selectedFamily);
        // Manual option prices inside THAT family
        selectedFamily?.prices?.forEach((price) => {
          if (price.manualOptionPrices && price.manualOptionPrices.length > 0) {
            const matchedPrices = price.manualOptionPrices.filter(
              (manualPrice) =>
                manualPrice.serviceProviderId === value?.serviceProviderId &&
                manualPrice.productId === product.productId
            );
            console.log("matchedPrices", matchedPrices);
            matchedPrices.forEach((manualPrice: any) => {
              const dateToUse = manualPrice.orderCreatedAt || manualPrice.updatedAt;
              if (dateToUse) {
                console.log(">>> Found date from manual option", {
                  optionName: price.name,
                  date: dateToUse,
                });
                console.log("manualPrice", manualPrice);
                allDates.push({
                  date: new Date(dateToUse).getTime(),
                  origin: `Manual Option: ${price.name}`,
                });
              }
            });
          }
        });
      } else {
        //  No family selected: Use ONLY product-level dates
        if (product.orderCreatedAt) {
          console.log(">>> Found date from product", {
            productName: product.productName,
            date: product.orderCreatedAt,
          });
          allDates.push({
            date: new Date(product.orderCreatedAt).getTime(),
            origin: `Product: ${product.productName}`,
          });
        }
      }
    });
    console.log(">>> Collected all possible dates", allDates);
    if (allDates.length === 0) {
      console.log(">>> No dates found for this provider");
      return null;
    }
    const mostRecent = allDates.reduce((prev, current) =>
      prev.date > current.date ? prev : current
    );

    console.log(">>> Resulting most recent date", mostRecent);
    return new Date(mostRecent.date);
  };

  const mostRecentDate = useMemo(() => {
    const date = getMostRecentOrderDate(products);
    return date;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products, value?.serviceProviderId, ...products.map((p) => p.selectedPriceFamilyId)]);

  const randomRate = useMemo(() => getRandomRate(), []);
  const randomRateCount = useMemo(() => getRandomRateCount(), []);
  return (
    <>
      <div style={{ fontWeight: "bold", fontSize: "14px" }} className="mt-1">
        {value?.serviceProviderName ?? ""}
      </div>
      {mostRecentDate && (
        <div className="mt-1" style={{ fontSize: "14px" }}>
          Commande passée le: {mostRecentDate.toLocaleDateString("fr-FR")}
        </div>
      )}
      <div className="rating mt-4">
        <Rate disabled value={randomRate} allowHalf />
        <span className="rate-value">{randomRateCount}</span>
      </div>
      {value?.formattedAddress && (
        <div className="mt-4" style={{ fontSize: "14px" }}>
          {value?.formattedAddress ?? ""}
        </div>
      )}
      {catalogPriceLineZones &&
        catalogPriceLineZones.map((catalogPriceLineZone, index) => (
          <div key={index}>
            {catalogPriceLineZone?.zoneName && (
              <div className="mt-4">
                <Tag color="blue">{catalogPriceLineZone?.zoneName ?? ""}</Tag>
              </div>
            )}
            {catalogPriceLineZone?.distanceByCar && (
              <div className="mt-4" style={{ fontSize: "14px" }}>
                <i>
                  Distance en voiture:{" "}
                  {parseFloat(
                    catalogPriceLineZone?.distanceByCar
                  ).toLocaleString("fr-FR", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                  })}{" "}
                  Km
                </i>
              </div>
            )}
          </div>
        ))}
    </>
  );
};

export default CatalogPriceServiceProviderCell;
